export const NAV_LINKS = [
  { label: 'Come Funziona', href: '#come-funziona' },
  { label: 'Servizi', href: '#servizi' },
  { label: 'Perché Noi', href: '#perche-noi' },
];

export const PROCESS_STEPS = [
  {
    n: '01',
    time: '3 minuti',
    title: 'Ci racconti cosa ti serve',
    body:
      "Compili il questionario iniziale: cosa fai, chi sono i tuoi clienti, cosa ti aspetti dal sito. Bastano tre minuti. Da l\u00ec partiamo noi.",
  },
  {
    n: '02',
    time: 'entro 48h',
    title: 'Call di allineamento',
    body:
      "Ti richiamiamo, approfondiamo, ti diciamo cosa pensiamo di fare e, importante, se non \u00e8 il caso te lo diciamo senza girarci intorno.",
  },
  {
    n: '03',
    time: 'preventivo chiaro',
    title: 'Preventivo trasparente e via',
    body:
      "Ti mandiamo un preventivo dettagliato col pacchetto scelto (mensile o annuale) e tutti i servizi inclusi. Tutto scritto, fermo, niente costi aggiuntivi a sorpresa lungo il percorso. Confermi e partiamo.",
  },
  {
    n: '04',
    time: 'da 7 a 14 giorni',
    title: 'Costruiamo il sito. Davvero.',
    body:
      "Design, copy, sviluppo. Ti scriviamo quando c'\u00e8 qualcosa di concreto da farti vedere, non per darti l'impressione che siamo attivi.",
  },
  {
    n: '05',
    time: 'consegna & online',
    title: 'Consegna e messa online',
    body:
      "Ti mostriamo il sito finito, navigabile come lo sar\u00e0 dal vivo. Lo pubblichiamo, \u00e8 tuo, e parte il pacchetto che hai scelto: mensile a partire da 25\u20ac o annuale a partire da 300\u20ac, con assistenza, hosting e SSL inclusi.",
  },
];

export const SERVICES = [
  {
    n: '01',
    icon: 'Users',
    title: 'Gestione Social Media',
    desc: 'Ci occupiamo della presenza social dalla A alla Z. Strategia, contenuti, pubblicazione.',
    tags: ['Strategia editoriale', 'Copywriting', 'Grafica, video, reel', 'Pubblicazione e calendario'],
  },
  {
    n: '02',
    icon: 'Megaphone',
    title: 'Advertising',
    desc: 'Campagne Meta, Google, TikTok, LinkedIn. Setup, gestione, ottimizzazione.',
    tags: ['Meta \u00b7 Google \u00b7 TikTok \u00b7 LinkedIn', 'Targeting, retargeting, lookalike', 'Report e analisi'],
  },
  {
    n: '03',
    icon: 'Palette',
    title: 'Logo e Brand Design',
    desc: 'Identit\u00e0 visiva che riconosci anche al buio.',
    tags: ['Logo', 'Palette, tipografia, stile', 'Brand guidelines', 'Declinazioni su tutti i materiali'],
  },
  {
    n: '04',
    icon: 'Search',
    title: 'SEO e Posizionamento',
    desc: 'Ti trovano quando ti cercano. E anche quando non sanno ancora che servi a loro.',
    tags: ['Ottimizzazione on-page e tecnica', 'Strategia keyword', 'Local SEO', 'Monitoraggio e report'],
  },
  {
    n: '05',
    icon: 'Mail',
    title: 'Email Marketing e Automazioni',
    desc: 'Sequenze che vendono mentre dormi.',
    tags: ['Welcome, nurturing, recupero carrello', 'Newsletter periodiche', 'Segmentazione'],
  },
  {
    n: '06',
    icon: 'Compass',
    title: 'Consulenza Strategica',
    desc: 'Prima di sparare, decidiamo dove mirare.',
    tags: ['Analisi mercato e competitor', 'Funnel e customer journey', 'Posizionamento'],
  },
  {
    n: '07',
    icon: 'Type',
    title: 'Copywriting e Content',
    desc: 'Testi che convincono, non che riempiono.',
    tags: ['Pagine web e landing', 'Articoli SEO', 'Script video e podcast', 'Ad copy'],
  },
  {
    n: '08',
    icon: 'Camera',
    title: 'Fotografia e Video',
    desc: 'Shooting professionali, editing, post-produzione.',
    tags: ['Foto prodotto, team, location', 'Video corporate e promo', 'Editing'],
  },
];

export const PACKAGES = [
  {
    id: 'business',
    icon: 'Briefcase',
    name: 'Sito Aziendale',
    sub: 'Pi\u00f9 pagine \u00b7 Area news',
    badge: null,
    desc: 'Per realt\u00e0 strutturate che hanno bisogno di pi\u00f9 pagine, area news/blog e gestione contenuti.',
    monthly: '25',
    yearly: '300',
    features: ['Pagine illimitate', 'Area news / blog', 'Multilingua opzionale', 'Pagina lavora con noi', 'CMS interno'],
  },
  {
    id: 'ecommerce',
    icon: 'ShoppingBag',
    name: 'E-commerce',
    sub: 'Vendi online',
    badge: null,
    desc: 'Il tuo negozio online leggero e ordinato, con pagamenti sicuri e gestione ordini integrata.',
    monthly: '33,30',
    yearly: '400',
    features: ['Catalogo prodotti', 'Pagamenti Stripe / PayPal', 'Gestione ordini', 'Spedizioni', 'Codici sconto'],
  },
  {
    id: 'booking',
    icon: 'CalendarDays',
    name: 'Booking',
    sub: 'Prenotazioni online',
    badge: null,
    desc: 'I tuoi clienti prenotano da soli, tu non rispondi pi\u00f9 al telefono. Ideale per studi, ristoranti, palestre.',
    monthly: '50',
    yearly: '600',
    features: ['Calendario online', 'Promemoria automatici', 'Pagamento anticipo', 'Gestione disponibilit\u00e0', 'Email transazionali'],
  },
];

export const ALWAYS_INCLUDED = [
  { icon: 'Zap', label: 'Velocit\u00e0 massima' },
  { icon: 'LifeBuoy', label: 'Assistenza tecnica' },
  { icon: 'ShieldCheck', label: 'Certificato SSL' },
  { icon: 'Smartphone', label: 'Ottimizzazione mobile' },
];

export const SITE_TYPES = [
  {
    n: '01',
    icon: 'Store',
    title: 'Sito Vetrina',
    desc: 'Una presenza online curata e veloce. Per professionisti, studi, attivit\u00e0 locali che vogliono farsi trovare bene.',
    tags: ['Fino a 6 pagine', 'SEO base', 'Form contatti', 'Mappa e orari'],
  },
  {
    n: '02',
    icon: 'ShoppingBag',
    title: 'E-commerce',
    desc: 'Vendi online con un negozio leggero, ordinato, che non ti tradisce nel checkout.',
    tags: ['Catalogo prodotti', 'Pagamenti Stripe / PayPal', 'Spedizioni', 'Gestione ordini'],
  },
  {
    n: '03',
    icon: 'Rocket',
    title: 'Landing Page',
    desc: 'Una sola pagina, pensata per convertire. Per lanci di prodotto, campagne ads, eventi.',
    tags: ['Copy persuasivo', 'A/B test', 'Tracking conversioni', 'Integrazione ads'],
  },
  {
    n: '04',
    icon: 'Briefcase',
    title: 'Sito Aziendale',
    desc: 'Per realt\u00e0 strutturate. Pagine team, servizi, casi studio, area news. Multilingua se serve.',
    tags: ['Multilingua', 'Area news / blog', 'Pagina lavora con noi', 'CMS interno'],
  },
  {
    n: '05',
    icon: 'Image',
    title: 'Portfolio',
    desc: 'Per fotografi, designer, creativi. Le tue immagini al centro, navigazione che non disturba.',
    tags: ['Gallerie immagini', 'Case study', 'Aree riservate cliente', 'Download protetti'],
  },
  {
    n: '06',
    icon: 'CalendarDays',
    title: 'Booking / Prenotazioni',
    desc: 'Per studi, ristoranti, b&b, palestre. I tuoi clienti prenotano da soli, tu non rispondi al telefono.',
    tags: ['Calendario online', 'Promemoria automatici', 'Pagamento anticipo', 'Gestione disponibilit\u00e0'],
  },
];

export const REASONS_TOP = [
  { tag: '/1', title: 'Prezzo onesto', body: 'Tre pacchetti chiari, da 25\u20ac/mese. Quello vedi, quello paghi.' },
  { tag: '/2', title: 'Studente, non agenzia', body: 'Sono uno studente di Biella che lavora da solo. Niente account manager, parli sempre con me.' },
  { tag: '/3', title: 'AI come strumento', body: 'Uso l\'intelligenza artificiale per andare veloce, mantenere prezzi bassi e dedicarti tempo vero.' },
];

export const REASONS_LIST = [
  {
    n: '/ 01',
    title: 'Prezzo trasparente, scritto e fermo.',
    body: 'Niente preventivi che si gonfiano strada facendo. Tre pacchetti chiari, prezzo mensile o annuale, tutto scritto e fermo fin dal primo messaggio su WhatsApp.',
  },
  {
    n: '/ 02',
    title: 'AI + persona, non un\'agenzia.',
    body: 'Costruisco i siti usando l\'intelligenza artificiale come strumento. Questo mi permette di andare veloce, tenere prezzi onesti e dedicarti tempo vero invece di scaricarti su un account manager o un fornitore.',
  },
  {
    n: '/ 03',
    title: 'Una persona, non cinque interlocutori.',
    body: 'Sito, contenuti, ottimizzazione, manutenzione: lo gestisco io, da Biella. Mi scrivi su WhatsApp, ti rispondo io. Niente filtri, niente passaggi di consegne.',
  },
  {
    n: '/ 04',
    title: 'Diciamo anche "no".',
    body: 'Se il tuo progetto non \u00e8 pronto o non \u00e8 il caso, te lo dico. Lavorare a vuoto non serve a nessuno dei due.',
  },
];
